export class DemographicGovtQuestions {
  constructor(sQuestionId: number , sAnswerFlag: boolean ) {
    this.sAnswerFlag = sAnswerFlag;
    this.sQuestionId = sQuestionId;
  }
  sQuestionType: string;
  sAnswerFlag: boolean;
  sQuestionId : number;
  sEthnicityType : number;
  sGenderType : number;
  sRaceType : number;
  sEthnicityTypeDesc : string;
  sGenderTypeDesc : string;
  sRaceTypeDesc : string;
  sDemograhicInfoProvidedDate = "";
  sApplicationSignedDate = "";
  sApplicationTakenMethodType : number;
  sApplicationTakenMethodTypeDesc : string;
  sAnswerExplain ="";
  sHMDAEthnicityRefusalIndicator: boolean;
  sHMDAGenderRefusalIndicator: boolean;
  sHMDARaceRefusalIndicator: boolean;
  sHMDAEthnicityVisualIndicator : boolean;
  sHMDAGenderVisaulIndicator : boolean;
  sHMDARaceVisualIndicator : boolean;




}
